// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:45:06+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            63a0b729648db05c21789f0753a8f51d
//    Signature:      eyJpdiI6ImdNYXRBUEtYWWFmSWt4Z0dneEZDMnc9PSIsInZhbHVlIjoiYlYyelVnODBubEdwYlwvYTVuMXRQck5lQTBVTHdYU1B5VndMRnNxcGExMXV0aE5IRWVTRzRUc3NIV3N0MGEwMURGZlFoY29tY2FBdk1LRUNJYTRRYmVLVFltM3I4eDFCY29IMmJ1THNUT2NzdFdXSE4yMjlQaTc3WDFBYXJNU2tqbFpaS1JcL2dneXdxSU5leXk1SGFQUjVXNVwvMVQ1ejYzUWwzVVBlbFVsR2pOMkwzWThZWGM3dlhHY0loWnFcL2FkZklRMmRaRUFXaTBrMzlqSXhhOFpUWHd1dysydk9QQXRGbldaQnpVQmRNWDlDaytJVFBoN1FRN1wvVFd2OFZMR3Btc0h2NHI3XC9ZWUt6XC9LNVFLNmFEOGhvWmZBT1BjSFFnUVRFUnR3OXJJN3Z5cHZNOHBJcFF0dXBDOVlaU1pMcElNNjBWcXVlbnc0R3VkM1VnK2hKSU1UcDBUNHBQVFlUa1kyRjBsU081Z245SXBvbWJlN2k3anh3dVpBVEZVdTVzV0JoWXRENVIwdVE5TThpbzdpQ0tPTVE9PSIsIm1hYyI6ImE1NGVhMjczMjczOGYxNmI0Zjk4YjM1ZmRmYzNhMWVkMGJkMGYyNDkyYTg5ZWNhNDM1MGQ5YzFmYzRmZGVjNTQifQ==
// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
